import { L } from '@lang';
import { Placeholder, CopyLink } from '../../../../shared/ui';
import { ReactComponent as LogoIcon } from '../../../../shared/assets/logo.svg';

interface OtherInstallCopyProps {
  host: string;
  origin: string;
}

export function OtherInstallCopy(props: OtherInstallCopyProps) {
  const { host, origin } = props;

  return (
    <Placeholder
      icon={<LogoIcon width={72} height={72} />}
      title={L.t('pwa_install_other_copy_title')}
      action={
        <CopyLink
          placeholder={`${host}/install/`}
          url={`${origin}/install/`}
          buttonLabel={L.t('pwa_install_other_copy_button')}
          copiedLabel={L.t('pwa_install_other_copy_button_copied')}
        />
      }
      stretched
    >
      {L.t('pwa_install_other_copy_subtitle')}
    </Placeholder>
  );
}
